






























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import AddPracticeForm from "@/components/AddPracticeForm.vue";
import { Action, namespace } from "vuex-class";
import {
  mdiAccountCircle,
  mdiPlusBox,
  mdiClipboardPulseOutline,
  mdiNewspaperVariantMultipleOutline,
  mdiMonitorDashboard,
  mdiLogout
} from "@mdi/js";

@Component
export default class SideMenu extends Vue {
  @namespace('auth').Action('logout') logout!: any;
  private theme: any = this.$vuetify.theme.themes.light;
  dialog: boolean = false;
  drawer: boolean = true;
  barBkgColor: string = "white";
  menuIcon: string = mdiAccountCircle;
  ProviderIcon: string = mdiPlusBox;
  menuIconColor: string = this.theme.primary;
  logoutIcon: string = mdiLogout;
  // addPracticeLink: string = "/addpractice";
  menuSelectedColor: string = 'white';
  menuBtnColor: string = this.theme.primary;
  menuBtnText: string = "Logout";
  menuTitle: string = "Admin";
  item: number = 1;
  items: any = [
    { title: "Dashboard", icon: mdiMonitorDashboard, link: "/" },
    { title: "Practices", icon: mdiClipboardPulseOutline, link: "/practice" },
    {
      title: "Reports",
      icon: mdiNewspaperVariantMultipleOutline,
      link: "/report"
    },
  ];

  menuSelected(item: any) {
    this.$root.$emit("SideMenuUpdate", item);
  }

  created() {
    this.$root.$on("toggleSideMenu", () => {
      this.drawer = !this.drawer;
    });
  }


}
